import api from './api';
import type { Site, SiteWithSnippet, CreateSiteForm, UpdateSiteForm } from '@/types';

interface SiteResponse {
  site: Site;
  tracking_snippet: string;
}

export const sitesService = {
  async list(orgId: string): Promise<Site[]> {
    const response = await api.get<{ sites: Site[] }>(`/api/organizations/${orgId}/sites`);
    return response.data.sites;
  },

  async get(siteId: string): Promise<SiteWithSnippet> {
    const response = await api.get<SiteResponse>(`/api/sites/${siteId}`);
    return {
      ...response.data.site,
      tracking_snippet: response.data.tracking_snippet,
    };
  },

  async create(orgId: string, data: CreateSiteForm): Promise<SiteWithSnippet> {
    const response = await api.post<SiteResponse>(`/api/organizations/${orgId}/sites`, data);
    return {
      ...response.data.site,
      tracking_snippet: response.data.tracking_snippet,
    };
  },

  async update(siteId: string, data: UpdateSiteForm): Promise<Site> {
    const response = await api.put<{ site: Site }>(`/api/sites/${siteId}`, data);
    return response.data.site;
  },

  async delete(siteId: string): Promise<void> {
    await api.delete(`/api/sites/${siteId}`);
  },

  async regenerateTrackingCode(siteId: string): Promise<SiteWithSnippet> {
    const response = await api.post<SiteResponse>(`/api/sites/${siteId}/regenerate-code`);
    return {
      ...response.data.site,
      tracking_snippet: response.data.tracking_snippet,
    };
  },
};

export default sitesService;
